import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { professionalAction, userActions } from "../../_actions";
import AropiReport2Plus from "./AropiReport";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Modal,
  Spin,
  Space,
  Typography,
  Dropdown,
  Menu,
} from "antd";
import {
  Document9,
  DocumentCount,
  DocumentCount1,
} from "./ReportDocuments/Document_9";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { ViewFormModel } from "./ViewForm/ViewFormModel";
import { TwoPlusService } from "../../_services/towplus.service";
import { twoPlusAction } from "../../_actions/twoplus.actions";
import MyTable from "./ReportDocuments/MyTable";
import { LanguageContext } from "../../context/LanguageContext";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  BarChartOutlined,
  ClearOutlined,
  DownOutlined,
  FilterOutlined,
  SearchOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { NCRServiceAction } from "../../_actions/ncr.service";
import { NCRTable } from "./Tables/NcrTable";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";

const { Text } = Typography;

const TableReport2Plus = React.lazy(() =>
  import("./Tables/TableReport2Plus").then((module) => ({
    default: module.TableReport2Plus,
  })),
);

const { RangePicker } = DatePicker;
const { Option } = Select;

class NCRReports extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }
  state = {
    total: 0,
    loading: false,
    downloadLoding: false,
    report_4_startDate: null,
    report_4_endDate: null,
    report4_loader: false,
    report4_List: [],
    showList: "list",
    showModal: false,
    download: "arophi_excel",
  };
  getExportRows = () => {
    const { t } = this.context;
    const arrData1 = this.state.report4_List;

    return this.state.showList === "list"
      ? arrData1?.map((data, index) => ({
          [t("sr.no")]: index + 1,
          [t("accused_police_station")]: data.districtName,
          [t("name")]: data.name,
          [t("age")]: data.age,
          [t("total_crimes")]: data.totalCrimeCount,
        })) || []
      : arrData1?.map((data, index) => ({
          [t("sr.no")]: index + 1,
          [t("accused_police_station")]: data?.districtName,
          [t("count")]: data?.count,
        })) || [];
  };

  download_pdf = async () => {
    const { t } = this.context;
    const arrData = this.getExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title = t("notice_register");
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: title,
        dateRangeText: getReportDateRangeText(
          this.state.report_4_startDate,
          this.state.report_4_endDate,
        ),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  downloadReport = () => {
    const { download, crimeTitle } = this.state;
    if (download == "arophi_excel" || download === "excel") {
      this.download_csv();
    }
    if (download === "pdf") {
      this.download_pdf();
    }
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  getDistrictsid = (id) => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };

  download_csv = () => {
    const { t } = this.context;
    var ReportTitle = "अदखलपात्र गुन्हा रजिस्टर";
    var title = "अदखलपात्र गुन्हा रजिस्टर";
    var arrData1 = this.state.report4_List;
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const list =
      this.state.showList === "list"
        ? arrData1?.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("accused_police_station")]: data.districtName,
            [t("name")]: data.name,
            [t("age")]: data.age,
            [t("total_crimes")]: data.totalCrimeCount,
          })) || []
        : arrData1?.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("accused_police_station")]: data?.districtName,
            [t("count")]: data?.count,
          }));

    const arrData = list;

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName = this.getCityName(this.props?.user?.cityId || "");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `From: ${
        moment(this.state.report_4_startDate).format("DD-MM-YYYY") || "-"
      } To ${moment(this.state.report_4_endDate).format("DD-MM-YYYY") || "-"}`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };
  onCityChange = () => {
    this.props.dispatch(
      professionalAction.getDistrict(this?.props?.user?.cityId, 1),
    );
  };

  componentDidMount() {
    const { user } = this.props;
    if (user && user.role !== "4") {
      this.setState({ showList: "list" });
    }

    if (user && user.role == "2") {
      this.getDistrictsid();
    }
    this.onCityChange();
    if (!this.props.professionals?.pc_crimetitles) {
      this.props.dispatch(professionalAction.getCrimeTitle());
    }
    this.props.dispatch(professionalAction.getCity());
  }

  getShowList = (value) => {
    this.setState({ showList: value });
  };

  onViewAccusedForm = (data) => {
    if (data) {
      let obj = {
        startDate: this.state.report_4_startDate,
        endDate: this.state.report_4_endDate,
        id: data,
        heading: this.state.crimeTitle,
      };
      this.props.dispatch(professionalAction.get2PlusCriminalsViewsById(obj));
      this.showCriminalViewModel();
    }
  };

  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };

  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };

  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.toISOString();

      this.setState({
        report_4_startDate: startDate,
        report_4_endDate: null,
      });
    }
  };
  onEndDateChange = (date) => {
    if (date) {
      const endDate = date.toISOString();

      this.setState({
        report_4_endDate: endDate,
      });
    }
  };

  getData = () => {
    this.setState({
      report4_loader: true,
    });
    const { showList, report_4_startDate, report_4_endDate } = this.state;
    const { user } = this.props;
    let startDate = moment(report_4_startDate).format("YYYY-MM-DD");
    let endDate = moment(report_4_endDate).format("YYYY-MM-DD");
    let obj;
    if (user.role === "2") {
      obj = {
        districtId: user.districtId,
        startDate: startDate,
        endDate: endDate,
      };
    }
    if (user.role === "4") {
      obj = {
        city: user.cityId,
        startDate: startDate,
        endDate: endDate,
      };
    }
    if (user.role === "9" || user.role === "10") {
      obj = {
        districtIds: user.map_districtId,
        startDate: startDate,
        endDate: endDate,
      };
    }
    if (showList === "list") {
      NCRServiceAction.NcrList(obj).then((res) => {
        res &&
          res.text().then((criminalList) => {
            let criminal = JSON.parse(criminalList);
            let list = criminal.results;
            console.log("list", list);
            this.setState({
              report4_loader: false,
              report4_List: list,
              total: list.length,
            });
          });
      });
    }
    if (showList === "count") {
      NCRServiceAction.NcrCount(obj).then((res) => {
        res &&
          res.text().then((criminalList) => {
            let criminal = JSON.parse(criminalList);
            let list = criminal.results;
            let totalCrimeCount = list.reduce(
              (sum, res) => sum + (Number(res.count) || 0),
              0,
            );
            console.log("list", list);
            this.setState({
              report4_loader: false,
              report4_List: list,
              total: totalCrimeCount,
            });
          });
      });
    }
  };
  sortby = (name, direction) => {
    this.setState({
      order_by: name,
      direction: direction,
    });

    const { report4_List } = this.state;

    const sortedData = [...report4_List].sort((a, b) => {
      let x = a[name] ?? "";
      let y = b[name] ?? "";

      // If both values are numeric strings → sort as numbers
      const isNumeric = !isNaN(x) && !isNaN(y);

      if (isNumeric) {
        x = Number(x);
        y = Number(y);
        return direction === "ASC" ? x - y : y - x;
      }

      // Otherwise sort as strings
      x = x.toString().toLowerCase();
      y = y.toString().toLowerCase();

      return direction === "ASC" ? x.localeCompare(y) : y.localeCompare(x);
    });

    this.setState({ report4_List: sortedData });
  };
  render() {
    const { showList, key, direction } = this.state;
    const { user } = this.props;
    const { professionals } = this.props;

    const { pc_cities, loading, pc_crimetitles } = professionals;
    const { language, t } = this.context;

    const menu = (
      <Menu onClick={this.filterkey} style={{ width: "200px", padding: "8px" }}>
        {this.state.showList == "list" ? (
          <>
            <Menu.Item key="totalCrimeCount">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                एकुण गुन्हे
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "totalCrimeCount" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("totalCrimeCount", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "totalCrimeCount" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("totalCrimeCount", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
            <Menu.Item key="name">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {t("name")}
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "name" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("name", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "name" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("name", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
          </>
        ) : (
          <>
            <Menu.Item key="count">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {t("total")}
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "count" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("count", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "count" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("count", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
          </>
        )}
      </Menu>
    );
    return (
      <>
        <Spin spinning={this.state.loading} delay={500}>
          <div className="col-md-6 col-md-offset-3">
            <div className="site-page-header-ghost-wrapper">
              <PageHeader
                className="site-page-header"
                ghost={false}
                onBack={false}
                title="अदखलपात्र गुन्हा रजिस्टर"
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <DatePicker
                    style={{ minWidth: "150px" }}
                    value={
                      this.state.report_4_startDate
                        ? moment(this.state.report_4_startDate)
                        : null
                    }
                    onChange={this.onStartDateChange}
                    placeholder="DD/MM/YYYY"
                    allowClear
                    format={"DD/MM/YYYY"}
                    inputReadOnly
                  />

                  <DatePicker
                    style={{ minWidth: "150px" }}
                    value={
                      this.state.report_4_endDate
                        ? moment(this.state.report_4_endDate)
                        : null
                    }
                    onChange={this.onEndDateChange}
                    placeholder="DD/MM/YYYY"
                    allowClear
                    format={"DD/MM/YYYY"}
                    inputReadOnly
                  />

                  <Button
                    type="primary"
                    loading={this.state.report4_loader}
                    disabled={
                      !this.state.report_4_endDate ||
                      !this.state.report_4_startDate
                    }
                    onClick={this.getData}
                  >
                    {t("find")}
                  </Button>

                  <Select
                    defaultValue={this.state.download}
                    placeholder={t("please_select_an_option")}
                    value={this.state.download || "excel"}
                    onChange={(value) => this.setState({ download: value })}
                    style={{ minWidth: "160px" }}
                  >
                    <Option key="arophi_excel">{t("accused_excel")}</Option>
                    <Option key="pdf">PDF</Option>
                  </Select>

                  {this.state.download && (
                    <Button
                      type="primary"
                      onClick={() => this.downloadReport()}
                      disabled={!this.state.report4_List?.length}
                    >
                      {t("download")}
                    </Button>
                  )}
                  <Dropdown
                    overlay={menu}
                    placement="bottomRight"
                    arrow
                    disabled={!this.state.report4_List?.length}
                  >
                    <Button type="ghost">
                      {t("sorter_by")} <DownOutlined />
                    </Button>
                  </Dropdown>
                </div>
              </PageHeader>

              <React.Suspense fallback={<div>Loading...</div>}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    width: "100%",
                    padding: "16px 0",
                  }}
                >
                  {/* View Type Selection */}
                  <div>
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        flexWrap: "wrap",
                        alignItems: "center",
                      }}
                    >
                      {user &&
                        (user.role === "4" ||
                          user.role === "9" ||
                          user.role === "10") && (
                          <Button
                            type={showList == "count" ? "primary" : "default"}
                            onClick={() => this.getShowList("count")}
                            icon={<BarChartOutlined />}
                            style={{
                              minWidth: "120px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "8px",
                            }}
                          >
                            {t("statistics")}
                          </Button>
                        )}

                      <Button
                        type={showList == "list" ? "primary" : "default"}
                        onClick={() => this.getShowList("list")}
                        icon={<UnorderedListOutlined />}
                        style={{
                          minWidth: "120px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                        }}
                      >
                        {t("list")}
                      </Button>
                    </div>
                  </div>
                </div>
                <NCRTable
                  data={this.state.report4_List}
                  showList={this.state.showList}
                  total={this.state.total}
                  onViewAccusedForm={this.onViewAccusedForm}
                  startDate={this.state.report_4_startDate}
                  endDate={this.state.report_4_endDate}
                  loading={this.state.report4_loader}
                  professionals={this.props.professionals}
                  user={this.props.user}
                />
              </React.Suspense>
              <Modal
                title="आरोपी प्रोफाइल"
                top
                visible={this.state.setCriminalViewModel}
                onOk={this.closeCriminalViewModel}
                onCancel={this.closeCriminalViewModel}
                width={95 + "%"}
              >
                <ViewFormModel
                  key={this.props && this.props.user.id}
                  dataStates={professionals}
                ></ViewFormModel>
              </Modal>
            </div>
          </div>
        </Spin>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedNCRReports = connect(mapStateToProps)(NCRReports);
export { connectedNCRReports as NCRReports };
